import { firestoreInstance } from 'config/ApiService';
import { USER_ACTIVITY } from 'core/utils/collectionNames';
import {
    addDoc,
    collection,
    getDocs,
    limit,
    orderBy,
    query,
    QueryConstraint,
    serverTimestamp,
    Timestamp
} from 'firebase/firestore';
import store from 'redux/store/store';

type EventName =
    | 'route_changed'
    | 'logged_off'
    | 'logged_in'
    | 'system_logged_off'
    | 'details_screen_visited'
    | 'scheduled_review_archived'
    | 'scheduled_review_completed'
    | 'chat_resolved'
    | 'scheduled_review_added'
    | 'note_added'
    | 'patient_discharged'
    | 'task_picked_up'
    | 'task_unpicked_up'
    | 'programme_reinstated'
    | 'tab_visited'
    | 'new_chat_started'
    | 'chat_message_sent';

export type TabName =
    | 'overview'
    | 'chat'
    | 'treatment_notes'
    | 'scheduled_reviews'
    | 'symptom_log'
    | 'programme'
    | 'episodes_of_care';

type EventDetails = {
    screen?: string | null;
    route_pattern?: string | null;
    visited_from?: string | null;
    tab_name?: TabName | null;
};

type UserActivity = {
    id: string;
    user_id: string;
    user_email: string;
    user_name: string;
    patient_id: string | null;
    event_name: EventName;
    created_at: Timestamp;
    details?: EventDetails | null;
};

type UserActivityData = {
    patientId?: string | null;
    eventName: EventName;
    eventDetails?: EventDetails | null;
};

export const getUsersActivities = async () => {
    const ref = collection(firestoreInstance(), USER_ACTIVITY);
    const constraints: QueryConstraint[] = [orderBy('created_at', 'desc'), limit(500)];

    const q = query(ref, ...constraints);
    const snapshots = await getDocs(q);
    let activityData: UserActivity[] = [];

    snapshots.forEach((snapshot) => {
        const data = snapshot.data() as UserActivity;
        activityData.push({
            ...data,
            id: snapshot.id
        });
    });

    return activityData;
};

export const setUserActivity = async ({ patientId, eventName, eventDetails }: UserActivityData) => {
    const { user } = store.getState().AuthReducer;

    if (!user?.id) {
        console.log('user is missing');
        return;
    }

    await addDoc(collection(firestoreInstance(), USER_ACTIVITY), {
        user_id: user.id,
        user_email: user.email,
        user_name: `${user.first_name} ${user.last_name}`,
        patient_id: patientId ?? null,
        event_name: eventName,
        created_at: serverTimestamp(),
        details: eventDetails ?? null
    });
};
